<select class="select form-control" >
	<option>Plop</option>
</select>